import { createFileRoute } from "@tanstack/react-router";
import { CreateWorkspacePage } from "../features/auth/CreateWorkspacePage";
import { useSession } from "../features/auth/session";
import { FullScreenSpinner } from "../features/shell/FullScreenSpinner";
import { Redirect } from "../features/shell/Redirect";

export const Route = createFileRoute("/new")({ component: New });

function New() {
  const session = useSession();
  if (session.status === "loading") return <FullScreenSpinner />;
  if (session.status === "anon") return <Redirect to="/login" search={{ next: "/new" }} replace />;
  return <CreateWorkspacePage />;
}
